// extracted by mini-css-extract-plugin
export default {"turnOffZebra":"BimWorkOrderChange_turnOffZebra__XMo2S","flickerPreventionLoader":"BimWorkOrderChange_flickerPreventionLoader__cxFN3"};